import React from 'react'
import { Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { dsColorNew } from '@palette'


// What a card or table says when it has nothing to show: the data tables' empty line, muted, with its folder
export default function AppEmptyLine({ children = 'Sorry, no matching records found', sx = {} }) {
	return <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, py: 2, fontSize: 13, color: dsColorNew.textMuted, ...sx }}>
		<IconSeeker icon="folder-open" iconWeight="regular" sx={{ fontSize: 15, color: dsColorNew.textSubtle }}/>
		{children}
	</Box>
}
